(ns manage.content-configuration-page.view.list
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Stack$default" :as Stack]
            [clojure.spec.alpha :as spec]
            [common.ui.list :as ui.list]
            [common.ui.validation.view :as validation]
            [manage.content-configuration-page.view.add-item :as add-item]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(defn published-cfg-read-only
  "ensure the list cfg updated to read-only if adset is published"
  [{:list/keys [add-item-cfg] :as cfg}]
  (if @(rf/subscribe [:resource.content-function-version/active-version? "published"])
    (letfn [(make-read-only [add-item-cfg] (assoc add-item-cfg :add-item/read-only? true))]
      (cond-> (assoc cfg :entity/read-only? true)
        (map? (not-empty add-item-cfg))
        (update :list/add-item-cfg make-read-only)
        (sequential? add-item-cfg)
        (update :list/add-item-cfg (fn [add-item-cfgs]
                                     (map make-read-only add-item-cfgs)))))
    cfg))

(rf/reg-sub :list/validation-summary-items
  (fn [[_ items-cfgs]]
    (map #(rf/subscribe [:entity/publish-blocking-errors-and-warnings %]) items-cfgs))
  (fn [validation-results _]
    (when-let [{:keys [publish-errors warnings total]}
               (not-empty (reduce (fn [acc {publish-errors :publish-blocking warnings :warning}]
                                    (cond-> acc
                                      publish-errors (update :publish-errors inc)
                                      warnings (update :warnings inc)
                                      (or publish-errors warnings) (update :total inc)))
                                  {} validation-results))]
      (when-let [type (validation/summary-type (pos? publish-errors) (pos? warnings))]
        {:summary-type type
         :validation-results [{:code :summary-message
                               :message (str (validation/summary-message type)
                                             " in " total " item" (when (> total 1) "s"))}]}))))

(defn- validation-summary-items
  "Renders summary validation list items"
  [items-cfgs]
  (when-let [{:keys [summary-type validation-results]} @(rf/subscribe [:list/validation-summary-items items-cfgs])]
    ($ Stack {:spacing 1
              :p 3
              :data-component :list-validation}
       ($ validation/alert-validation-list {:summary-type summary-type
                                            :validation-results validation-results}))))

(defn list-item-validation
  [_list-cfg {:validation/keys [render-type schema] :as item-cfg}]
  (when schema
    ($ validation/view-results {:stack-props {:px 2 :py 1}
                                :render-type (or render-type :unordered-list)
                                :validation-results-sub [:entity/publish-blocking-errors-and-warnings item-cfg]})))

(defn add-item [cfg add-item-cfg]
  (when-not (and (:entity/read-only? cfg) (:add-item/ignore-input? add-item-cfg))
    [:> Box {:data-component :add-item
             :p 3}
     [add-item/view (assoc add-item-cfg :add-item/parent (:entity/ref cfg))]]))

(defn list-content-before [{:validation/keys [render-type] :as cfg} items-cfgs]
  [:<>
   (when render-type
     ($ validation/view-results {:stack-props {:spacing 1
                                               :p 3
                                               :data-component :list-validation}
                                 :render-type render-type
                                 :validation-results-sub [:entity/publish-blocking-errors-and-warnings cfg]}))
   [validation-summary-items items-cfgs]
   (when-let [add-item-cfg (:list/add-item-cfg cfg)]
     (cond (map? add-item-cfg)
           [add-item cfg add-item-cfg]
           (sequential? add-item-cfg)
           [:> Stack {:direction "row"}
            (for [add-item-cfg1 add-item-cfg]
              ^{:key (str add-item-cfg1)} [add-item cfg add-item-cfg1])]))])

(defn view [cfg]
  [ui.list/view
   (-> (published-cfg-read-only cfg)
       (assoc :list/common-item-details list-item-validation)
       (update :list/content-before #(or % list-content-before)))])

(defn as-entity
  "converts a list view configuration to an entity view configuration with the
  list as contents in the entity view"
  [cfg]
  (assoc cfg :entity/content [view cfg]))

(defn as-tab
  "converts a list view configuration to a tab configuration for use within the
  tab layout component"
  [{:entity/keys [icon label label-element] :as cfg}]
  {:pre [(spec/assert :entity/label label)]}
  (cond-> {:label label
           :label-element label-element
           :content [view cfg]}
    (some? icon) (assoc :icon icon)))
